import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {RootState} from '../../store'
import {
  CreateUserRequest,
  CreateUserResponse,
  DeleteUserRequest,
  DeleteUserResponse,
  EditUserRequest,
  EditUserResponse,
  GetUserDetailRequest,
  GetUserDetailResponse,
  GetUserListRequest,
  GetUserListResponse,
} from '../interfaces/user'
import {setErrorModalMessage, setSuccessModalMessage} from '../../slices/messageSlice'
import {getRTKError} from '../../../libs/_fri/utils/helpers'
export const URL = `${process.env.REACT_APP_API_URL}/users/v1/`

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: URL,
    prepareHeaders: (headers, {getState}) => {
      const token = (getState() as RootState).authSlice.session_id
      headers.set('Authorization', `Bearer ${token}`)
      return headers
    },
  }),
  tagTypes: ['UserList'],
  endpoints: (builder) => ({
    getUserList: builder.query<GetUserListResponse, GetUserListRequest>({
      query: (data) => ({
        url: `list`,
        method: 'Post',
        body: data,
      }),
      providesTags: ['UserList'],
    }),
    getUserDetail: builder.mutation<GetUserDetailResponse, GetUserDetailRequest>({
      query: (data) => ({
        url: `detail`,
        method: 'POST',
        body: data,
      }),
      async onQueryStarted(arg, {dispatch, queryFulfilled}) {
        try {
          const result = await queryFulfilled
        } catch (err: any) {
          dispatch(setErrorModalMessage(getRTKError(err)))
        }
      },
    }),
    createUser: builder.mutation<CreateUserResponse, CreateUserRequest>({
      query: (data) => ({
        url: `create`,
        method: 'POST',
        body: data,
      }),
      async onQueryStarted(arg, {dispatch, queryFulfilled}) {
        try {
          const result = await queryFulfilled
          dispatch(
            setSuccessModalMessage({
              title: result.data.info.title,
              description: result.data.info.message,
            })
          )
        } catch (err: any) {
          dispatch(setErrorModalMessage(getRTKError(err)))
        }
      },
      invalidatesTags: ['UserList'],
    }),
    editUser: builder.mutation<EditUserResponse, EditUserRequest>({
      query: (data) => ({
        url: `edit`,
        method: 'POST',
        body: data,
      }),
      async onQueryStarted(arg, {dispatch, queryFulfilled}) {
        try {
          const result = await queryFulfilled
          dispatch(
            setSuccessModalMessage({
              title: result.data.info.title,
              description: result.data.info.message,
            })
          )
        } catch (err: any) {
          dispatch(setErrorModalMessage(getRTKError(err)))
        }
      },
      invalidatesTags: ['UserList'],
    }),
    deleteUser: builder.mutation<DeleteUserResponse, DeleteUserRequest>({
      query: (data) => ({
        url: `delete`,
        method: 'DELETE',
        body: data,
      }),
      async onQueryStarted(arg, {dispatch, queryFulfilled}) {
        try {
          const result = await queryFulfilled
          dispatch(
            setSuccessModalMessage({
              title: result.data.info.title,
              description: result.data.info.message,
            })
          )
        } catch (err: any) {
          dispatch(setErrorModalMessage(getRTKError(err)))
        }
      },
      invalidatesTags: ['UserList'],
    }),
  }),
})

export const {
  useGetUserListQuery,
  useCreateUserMutation,
  useEditUserMutation,
  useDeleteUserMutation,
  useGetUserDetailMutation,
} = userApi
